import { Field } from 'formik'

const CheckboxField = ({ name, label, ...props }) => {
  return (
    <div className="mt-3">
      <label className="flex items-start gap-3 cursor-pointer">
        <Field
          type="checkbox"
          name={name}
          className="mt-1 h-4 w-4 rounded text-brandSecondary focus:ring-brandSecondary border-brandSecondary"
          {...props}
        />
        <span className="flex-1 text-sm text-gray-900">{label}</span>
      </label>
    </div>
  )
}

export default CheckboxField